/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Pricing_FreemiumInputs */

const en_directory_pricing_freemium = /** @type {(inputs: Directory_Pricing_FreemiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freemium`)
};

const zh_directory_pricing_freemium = /** @type {(inputs: Directory_Pricing_FreemiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费增值`)
};

/**
* | output |
* | --- |
* | "Freemium" |
*
* @param {Directory_Pricing_FreemiumInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_pricing_freemium = /** @type {((inputs?: Directory_Pricing_FreemiumInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Pricing_FreemiumInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_pricing_freemium(inputs)
	return zh_directory_pricing_freemium(inputs)
});
export { directory_pricing_freemium as "directory.pricing.freemium" }